module.exports = __webpack_public_path__ + "img/191.4d2896d5.jpg";